var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAddNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 52,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-add-new_svg__filter0_d_4391_64687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 25c0-9.941 8.059-18 18-18h28c9.941 0 18 8.059 18 18s-8.059 18-18 18H26c-9.941 0-18-8.059-18-18z",
    fill: "#ED1B2E"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M42.737 15.762h-6.652a3.82 3.82 0 00-3.834 3.729V30.34a3.714 3.714 0 003.649 3.777c.06 0 .123 0 .185-.002h7.988a3.769 3.769 0 003.73-3.775v-9.3l-5.066-5.278z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.474 15.75v2.909a2.575 2.575 0 002.57 2.575h2.753M42.294 25.914h-4.9M39.844 28.364v-4.9",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-add-new_svg__filter0_d_4391_64687",
    x: 0,
    y: 0,
    width: 80,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_64687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4391_64687",
    result: "shape"
  })))));
}

export default SvgIconAddNew;